import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { LatLngTuple } from 'leaflet';

interface NetworkMapState {
  mapPosition: {
    center: LatLngTuple;
    zoom: number;
  };
}

interface NetworkMapActions {
  setMapPosition: (position: NetworkMapState['mapPosition']) => void;
}

type NetworkMapStore = NetworkMapState & NetworkMapActions;

export const useNetworkMapStore = create<NetworkMapStore>()(
  devtools((set, get) => {
    // Expose state to window object
    (window as any).getMapPosition = () => get().mapPosition;

    return {
      // State
      mapPosition: {
        center: [49.013854, 12.122648],
        zoom: 18.5 // Default to a closer zoom level
      },

      // Actions
      setMapPosition: (position: NetworkMapState['mapPosition']) => {
        // Ensure zoom stays within bounds (min: 8, max: 19)
        const boundedZoom = Math.min(Math.max(position.zoom, 8), 19);
        set(
          { 
            mapPosition: {
              ...position,
              zoom: boundedZoom
            }
          }, 
          false, 
          'setMapPosition'
        );
      }
    };
  })
);
